import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import AgriOrderProduct from '@/models/AgriOrderProduct.js'

export const useAgriOrderProductStore = defineStore('agriOrderProductStore', () => {
  let syncableModel = useSyncableModel(useApiResource('agri_order_products'), {
    className: AgriOrderProduct.modelName.name,
    paramKey: AgriOrderProduct.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }
}, {
  persist: true
})
